<template>
  <layout>
    <section class="section">
      <div class="columns">
        <div class="column">
          <div class="box">
            <h2>Add New Relationships</h2>
            <hr />
            <div class="columns">
              <div class="column">
                <form action="#">
                  <div class="columns">
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Name">
                        <b-input v-model="relationship_form.name"></b-input>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Is Manager">
                        <b-checkbox
                          v-model="relationship_form.is_manager"
                          :true-value="1"
                        ></b-checkbox>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Is Peer">
                        <b-checkbox
                          v-model="relationship_form.is_peer"
                          :true-value="1"
                        ></b-checkbox>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Is Internal">
                        <b-checkbox
                          v-model="relationship_form.is_internal"
                          :true-value="1"
                        ></b-checkbox>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Is External">
                        <b-checkbox
                          v-model="relationship_form.is_external"
                          :true-value="1"
                        ></b-checkbox>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Colour">
                        <v-swatches
                          v-model="relationship_form.color"
                          label="Colour"
                          :swatches="swatches"
                        ></v-swatches>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-button
                        class="button is-primary"
                        @click="addRelationship()"
                      >
                        Add
                      </b-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="box">
            <a id="overview"></a>
            <h3>Relationships</h3>
            <hr style="margin-top: 15px" />
            <div class="columns">
              <div class="column is-flex is-align-items-center">
                <b>Name</b>
              </div>
              <div class="column is-flex is-align-items-center">
                <b>Is Manager</b>
              </div>
              <div class="column is-flex is-align-items-center">
                <b>Is Peer</b>
              </div>
              <div class="column is-flex is-align-items-center">
                <b>Is Internal</b>
              </div>
              <div class="column is-flex is-align-items-center">
                <b>Is External</b>
              </div>
              <div class="column is-flex is-align-items-center">
                <b>Colour</b>
              </div>
              <div class="column is-flex is-align-items-center">
                <b>Actions</b>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-table
                  class="loadingTable"
                  :data="loadingRelationships"
                  v-if="loadingRelationships.length > 0"
                >
                  <b-table-column field="name" width="40" v-slot="props">
                    <b-field>
                      {{ props.row.name }}
                    </b-field>
                  </b-table-column>
                  <b-table-column
                    field="name"
                    width="40"
                    v-slot="props"
                    centered
                  >
                    <i>Loading</i>
                  </b-table-column>
                  <b-table-column
                    field="name"
                    width="40"
                    v-slot="props"
                    centered
                  >
                    <i>Loading</i>
                  </b-table-column>
                  <b-table-column
                    field="name"
                    width="40"
                    v-slot="props"
                    centered
                  >
                    <b-field>
                      <v-swatches
                        v-model="props.row.color"
                        :swatches="swatches"
                      ></v-swatches>
                    </b-field>
                  </b-table-column>
                </b-table>
                <div
                  class="relationship"
                  v-for="relationship in project.relationships"
                >
                  <form action="#" @change="updateRelationship(relationship)">
                    <div class="columns">
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <b-input v-model="relationship.name"></b-input>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <b-checkbox
                            v-model="relationship.is_manager"
                            :true-value="1"
                          ></b-checkbox>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <b-checkbox
                            v-model="relationship.is_peer"
                            :true-value="1"
                          ></b-checkbox>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <b-checkbox
                            v-model="relationship.is_internal"
                            :true-value="1"
                          ></b-checkbox>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <b-checkbox
                            v-model="relationship.is_external"
                            :true-value="1"
                          ></b-checkbox>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <v-swatches
                            v-model="relationship.color"
                            label="Colour"
                            :swatches="swatches"
                            @close="updateRelationship(relationship)"
                          ></v-swatches>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-button
                          type="is-danger"
                          size="is-small"
                          @click="deleteRelationship(relationship.unique_id)"
                        >
                          <b-icon
                            pack="fas"
                            icon="trash"
                            size="is-small"
                          ></b-icon>
                        </b-button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="relationship">
                  <form action="#">
                    <div class="columns">
                      <div class="column is-flex is-align-items-center">
                        <b-field> Self </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field> </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field> </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field> </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field> </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field>
                          <v-swatches
                            label="Colour"
                            :swatches="swatches"
                            disabled="disabled"
                            value="#3B3838"
                          ></v-swatches>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-justify-content-flex-end">
          <inertia-link
            :href="route('projects.setup.participants', project.unique_id)"
          >
            <b-button
              :disabled="project.relationships.length < 1"
              class="button is-primary"
              >Next</b-button
            >
          </inertia-link>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from '../Layout';

import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';

class Relationship {
  constructor(args) {
    this.name = args.name ?? '';
    this.is_manager = args.is_manager ?? '';
    this.is_peer = args.is_peer ?? '';
    this.is_peer = args.is_internal ?? '';
    this.is_peer = args.is_external ?? '';
    this.color = args.color ?? '';
  }
}

export default {
  components: {
    Layout,
    VSwatches,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      relationship_form: { color: '#FF0000' },
      loadingRelationships: [],
      swatches: [
        '#3B3838',
        '#FF0000',
        '#0033CC',
        '#00B0F0',
        '#FFC000',
        '#7030A0',
        '#bfff00',
        '#ff007f',
      ],
    };
  },
  methods: {
    addRelationship: function () {
      this.loadingRelationships.push(this.relationship_form);
      this.submitNewRelationship(this.loadingRelationships.length - 1);
      this.relationship_form = new Relationship({
        name: '',
        is_manager: 0,
        is_peer: 0,
        is_internal: 1,
        is_external: 1,
        color: '#cc0001',
      });
    },
    submitNewRelationship: function (index) {
      this.$inertia.post(
        route('projects.setup.newRelationship', this.project.unique_id),
        this.relationship_form,
        {
          onFinish: () => {
            this.loadingRelationships.splice(index, 1);
          },
        }
      );
    },
    deleteRelationship: function (relationshipId) {
      this.$inertia.post(
        route('projects.setup.deleteRelationship', relationshipId),
        this.relationship_form
      );
    },
    updateRelationship: function (relationship) {
      this.$inertia.put(
        route('projects.setup.updateRelationship', relationship.unique_id),
        relationship
      );
    },
  },
};
</script>
